import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './bankConnectScreen.module.css';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import { BANK_CONNECT_COPY } from '../../helper/constants';

const BankConnectScreen = ({ logo, steps }) => (
    <ScreenFrame
        logo={logo}
        stepper={steps && <Stepper steps={steps} activeStep={1} />}
        bodyClassName={styles.body}
    >
        <CircularProgress
            variant="determinate"
            value={75}
            size={32}
            thickness={2.75}
            className={styles.spinner}
        />
        <Box className={styles.text}>
            <Typography className={styles.title}>{BANK_CONNECT_COPY.TITLE}</Typography>
            <Typography className={styles.subTitle}>{BANK_CONNECT_COPY.SUB_TITLE}</Typography>
        </Box>
    </ScreenFrame>
);

BankConnectScreen.propTypes = {
    logo: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
};

export default BankConnectScreen;
